import React from 'react';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';

import { ActivationEvent } from './activate-product-sidebar';

interface Props {
  onLoading: (isLoading: boolean) => void;
  onClose: (event: ActivationEvent) => void;
}

/**
 * Renders an informative message to the user regarding the props received.
 * @param {Props} props
 * @returns {JSX.Element}
 */
export const InformativeDialogContent: React.FC<Props> = ({ onLoading, onClose }: Props) => {
  React.useEffect(() => {
    onLoading(false);
  }, [onLoading]);

  return (
    <Form
      stickyFooter
      leftSideButtons={
        <Button onClick={onClose} buttonType="secondary">
          <FormattedMessage id="common.close" defaultMessage="Close" />
        </Button>
      }
    >
      <div>
        <p>
          <FormattedMessage
            id="billing.something_has_gone_wrong"
            defaultMessage={`
              Something has gone wrong! Refresh the page and try upgrading again. Please contact us if it persists.
            `}
          />
        </p>
      </div>
    </Form>
  );
};
